module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "figa"
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }), _c('a', {
    attrs: {
      "id": "page2"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg3_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copyg"
  }, [_c('i', [_vm._v("Simply Stars")]), _vm._v(" is designed not only for the quiltmaker, but also for those who are interested in teaching it as a class. A suggested class outline follows the projects.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Editor: Lee Jonsson")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Technical Editor: Joyce Engels Lytle")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Copy Editor: Judith M. Moretz")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Cover and book design: Rose Sheifer Graphic Productions")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Electronic illustrations: Rose Sheifer Graphic Productions")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Photography: Sharon Risedorph")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Author photo: Michael Stefanski")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c9298c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/02_copyright.vue
// module id = 60
// module chunks = 0